import { Injectable } from '@angular/core';

import { ZonarUiNotificationsService } from '@zonar-ui/notifications';

import { TOAST_MESSAGE_DURATION_SECONDS } from '@src/app/constants/messages.constants';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(
    private notifications: ZonarUiNotificationsService,
  ) {}

  showSuccessNotification(title: string) {
    this.notifications.openSuccess(title, '', TOAST_MESSAGE_DURATION_SECONDS);
  }
  
  showErrorNotification(title: string) {
    this.notifications.openError(title, '', TOAST_MESSAGE_DURATION_SECONDS);
  }
}

